import { customFetch } from '../lib/network/Axios';
import type { OwnerTourState } from '../types/ownerTour.types';

const BASE = '/kiosk-registrations/me/tour';

export async function getOwnerTour(): Promise<OwnerTourState> {
  const response = await customFetch.get(BASE);
  return response.data as OwnerTourState;
}

export async function saveOwnerTourProgress(currentStep: number, completedSteps: number[]): Promise<OwnerTourState> {
  const response = await customFetch.put(`${BASE}/progress`, { currentStep, completedSteps });
  return response.data as OwnerTourState;
}

export async function completeOwnerTour(): Promise<OwnerTourState> {
  const response = await customFetch.post(`${BASE}/complete`);
  return response.data as OwnerTourState;
}

export async function dismissOwnerTour(): Promise<OwnerTourState> {
  const response = await customFetch.post(`${BASE}/dismiss`);
  return response.data as OwnerTourState;
}

export async function restartOwnerTour(): Promise<OwnerTourState> {
  const response = await customFetch.post(`${BASE}/restart`);
  return response.data as OwnerTourState;
}
